module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    class: _vm.headerClass
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v("Summary")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    class: _vm.subheaderClass
  }, [_vm._l((_vm.AverageTotal), function(at, index) {
    return [_c('v-toolbar', {
      class: _vm.toolbarClass,
      attrs: {
        "dense": true
      }
    }, [_vm._v("\n                            " + _vm._s(index) + "\n                            "), _c('v-spacer'), _vm._v("\n                            " + _vm._s(at) + "\n                        ")], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39b407fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summarySection.vue
// module id = 1278
// module chunks = 1